<template>
  <div data-animate="list" class="listing-rows-list">
    <article v-for="item in items" :key="item.id" class="m-top-5">
      <div class="listing-rows-list__item">
        <div
          class="flex --justify-space-between --align-center"
          data-animate="header-content"
        >
          <h2 class="text-xxl">{{ item.title }}</h2>

          <WidgetLinkMainUnderline
            :text="'text-ms'"
            :link="{
              key: 'view-all-products',
              route: item.route,
            }"
          />
        </div>

        <ul data-animate="list" class="listing-rows-list__list m-top-24px">
          <li v-for="child in item.children" :key="child.id">
            <WidgetContentBlock :content="child" :key="child.id" />
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'ListingRowsList',
}
</script>

<script setup>
const props = defineProps({
  items: Array,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
